import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useHistory } from "react-router-dom";

// Custom components
import colors from "../../constants/Colors";
import landscape from "../../assets/landscapeSmallBanner.png";

const Success = ({ isComplete, t }) => {
  // initialize timeLeft with the seconds prop
  const [timeLeft, setTimeLeft] = useState(3);
  let history = useHistory();

  useEffect(() => {
    if (isComplete) {
      // exit early when we reach 0
      if (timeLeft <= 0) {
        history.push("adminpage/organisations");
        return;
      }

      // save intervalId to clear the interval when the
      // component re-renders
      const intervalId = setInterval(() => {
        setTimeLeft(timeLeft - 0.5);
      }, 250);

      // clear interval on re-render to avoid memory leaks
      return () => clearInterval(intervalId);
      // add timeLeft as a dependency to re-rerun the effect
      // when we update it
    }
  }, [timeLeft, isComplete, history]);

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          position: "relative",
          height: "100%",
          textAlign: "center",
        }}
      >
        <CheckCircleIcon
          style={{
            fontSize: 80,
            color: colors.mainGreen,
            margin: "10px 0 0 0",
          }}
        />
        <h1 style={{ color: colors.mainGreen, margin: 0 }}>
          {t("auth.success")}
        </h1>
        <p style={{ fontWeight: 500, marginTop: 10, marginBottom: 40 }}>
          {"Automatic log in, in "}
          <span style={{ fontWeight: 600 }}>
            3...
            {timeLeft <= 2.5 && "2..."}
            {timeLeft <= 1.5 && "1..."}
            {timeLeft <= 0.5 && t("auth.liftoff")}
          </span>
        </p>
        <img
          src={landscape}
          alt=""
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
          }}
        />
      </div>
    </div>
  );
};

export default withTranslation("common")(Success);
